import { render, staticRenderFns } from "./MalletIcon.vue?vue&type=template&id=5b006266&"
import script from "./MalletIcon.vue?vue&type=script&lang=ts&"
export * from "./MalletIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports